module.exports = __webpack_public_path__ + "img/emo_005.73edbf54.png";